import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { PATH } from '@/constants/path';
import { BlockStack, Button, Card } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ImgStyled, MinHeightStyled } from '../styled';
import { THUMBNAIL } from '@/helpers/link';
import { XIcon } from '@shopify/polaris-icons';

interface IProps {
  handleSkip?: () => void;
}

const OnboardingFinish = ({ handleSkip }: IProps) => {
  const { t } = useTranslation('onboarding');
  const navigate = useNavigate();
  return (
    <Card>
      <div className="flex justify-end">
        <Button icon={XIcon} variant="tertiary" onClick={handleSkip}></Button>
      </div>
      <MinHeightStyled>
        <BlockStack gap={'400'} inlineAlign="center">
          <BlockStack gap="200">
            <ImgStyled>
              <img width={170} src={THUMBNAIL.ONBOARDING_FINISH_IMG} alt="onboarding_finish_img" />
            </ImgStyled>
            <BoldText variant="headingXl" alignment="center">
              {t('finish.finishTitle')}
            </BoldText>
            <RegularText variant="bodyLg">{t('finish.helpText')}</RegularText>
          </BlockStack>
          <div className="flex gap-8">
            <Button variant="secondary" onClick={() => navigate(PATH.PRICING.pathname)}>
              {t('finish.button.plan')}
            </Button>
            <Button variant="primary" onClick={() => navigate(PATH.DEFAULT.pathname)}>
              {t('finish.button.dashboard')}
            </Button>
          </div>
        </BlockStack>
      </MinHeightStyled>
    </Card>
  );
};

export default OnboardingFinish;
